/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audio-manage.vue?vue&type=template&id=25d90eff&scoped=true&"
import script from "./audio-manage.vue?vue&type=script&lang=ts&"
export * from "./audio-manage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d90eff",
  null
  
)

export default component.exports